import Vue, {createApp, defineComponent} from 'vue'
import $ from 'jquery'
import {ENV, FEED_BACK_STATE, UX} from '../Constant'
const FeedbackResult = require('./ResultTemplate.vue')
// import toastr from 'toastr'
import Mixin from '../../mixin'
//import PublicIP from 'public-ip'
import {mixins,Watch} from "vue-property-decorator";

const toastr = require('toastr')
const PublicIP = require('public-ip')

let dataBck = {}

const templateCss =
  '<style>#result{font-family:"Trebuchet MS",Arial,Helvetica,sans-serif;border-collapse:collapse;width:100%}#result td,#result th{border:1px solid #ddd;padding:8px}#result tr:nth-child(even){background-color:#f2f2f2}#result tr:hover{background-color:#ddd}#result th{padding-top:12px;padding-bottom:12px;text-align:left;background-color:#cf373a;color:#fff}#result ul{margin-bottom:10px}ul{padding:3px;margin:0}ul li{list-style-type:none}p{margin:3px 0}p.msg{color:green;margin-top:5px}h5.other{margin-bottom:5px}</style>'

export default class FeedBackForm extends mixins(Mixin){
  publicIp:string = ''
  isShowModal:boolean = false
  step:number = 1
  step1 = {
    rate: 0
  }
  step2 = {
    rate: '' //normal, easy, hard
  }
  step3 = {
    improve: {
      ui: false, //giao diện đẹp hơn
      feature: false, //thêm tính năng
      content: false, //Nội dung chính xác hơn
      other: false //Khác
    },
    otherMsg: '' //Nội dung khác
  }
  isSending:boolean = false
  state:string = FEED_BACK_STATE.COMPOSING //finished

  get step1Icon() {
    let rate = this.step1.rate
    if (rate < 5) return 'face_01.png'
    else if (rate < 7) return 'face_02.png'
    else if (rate < 9) return 'face_03.png'
    else return 'face_04.png'
  }
  get step1Msg() {
    let rate = this.step1.rate
    if (rate < 5) return 'Tôi sẽ không giới thiệu'
    else if (rate < 7) return 'Tôi có thể sẽ không giới thiệu'
    else if (rate < 9) return 'Tôi có thể sẽ giới thiệu'
    else return 'Tôi sẽ giới thiệu ngay'
  }
  get canNext() {
    if (this.step == 1 && this.step1.rate > 0) {
      return true
    } else if (this.step == 2 && this.step2.rate !== '') {
      return true
    } else {
      return false
    }
  }
  get formApi() {
    return `${ENV.VUE_APP_FORM_API}/mapi`
  }
  get UX() {
    return UX
  }
  get ratingPoints() {
    return 10
  }
  get canSubmit(): number | string {
    return this.step1.rate && this.step2.rate
  }


  @Watch('step')
  private changeStep(newVal:number, oldVal:number): void {
    $('#step-form-' + oldVal).fadeOut(150)
    $('#step-form-' + newVal).fadeIn(150)
  }

  onClickNext() {
    if (!this.canNext) {
      return false
    }
    this.gotoStep(this.step + 1)
  }
  showModal() {
    this.isShowModal = true
  }
  gotoStep(step:number) {
    this.step = step
  }
  selectStep1Rate(rate:number) {
    this.step1.rate = rate
  }
  selectStep2Rate(rate:string) {
    this.step2.rate = rate
  }
  onSelectOtherMsg(order:number) {
    if (this.step3.improve.other) {
      setTimeout(() => (this.$refs['msg' + order] as HTMLElement).focus(), 200)
    }
  }
  onClickSend() {
    if (this.isSending && !this.canSubmit) {
      return
    }

    let title = 'Rever feedback'
    const el = document.createElement('div')

    const FeedbackResultComponent = defineComponent({extends: FeedbackResult});
    const vm = new FeedbackResultComponent({
      propsData: {
        ...this.$data,
        ip: this.publicIp,
        userAgent: navigator.userAgent,
        templateCss: templateCss,
        pageUrl: location.href
      }
    })
    createApp(vm).mount(el);
    vm.$nextTick(() => {
      let html = vm.$el.innerHTML
      this.isSending = true
      $.ajax({
        url: `${this.formApi}/form/feedback_internal`,
        method: 'POST',
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        },
        data: JSON.stringify({
          title: title,
          message: `<!DOCTYPE html><html><head>${templateCss}</head><body> ${html}</body></html>`
        }),
        dataType: 'json',
        success: resp => {
          if (resp && !resp.error) {
            this.state = FEED_BACK_STATE.FINISHED
          } else {
            toastr.error('Rất tiếc! có lỗi xảy ra.')
          }
        },
        error: error => {
          toastr.error(`Rất tiếc! có lỗi xảy ra. <br/> ${error}`)
        }
      }).always(() => {
        this.isSending = false
      })
    })
  }
  hideModal() {
    if (this.state === FEED_BACK_STATE.FINISHED) {
      this.resetState()
    }
    this.isShowModal = false
  }
  resetState() {
    let orginData = Object.assign({}, dataBck)
    this.copyObject(orginData, this.$data)
  }
  copyObject(from:any, to:any) {
    for (let x in from) {
      to[x] = from[x]
    }
  }

  created() {
    PublicIP.v4().then((ip:string) => {
      this.publicIp = ip
    })
  }
  mounted() {
    dataBck = Object.assign({}, this.$data)
  }
}
